import { useTheme } from "@emotion/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Arrange, Avatar, Typography } from "@aviary";
import FullscriptLogoGreenLeafPigeonTextSVGComponent from "@shared/assets/logo/FullscriptLogoGreenLeafPigeonText";
import FullscriptLogoWhiteTextGreenLeafSVGComponent from "@shared/assets/logo/FullscriptLogoWhiteTextGreenLeaf";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./PatientInfoBlock.styles";

interface Props {
  storeName: string;
  pracAvatar?: string;
  children: ReactNode;
}

const PatientInfoBlock = ({ children, storeName, pracAvatar }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const fsLogo = () => {
    if (theme.theme === "dark") {
      return (
        <FullscriptLogoWhiteTextGreenLeafSVGComponent
          css={styles.svgContainer}
          data-testid="fullscript-logo-dark"
        />
      );
    }

    return (
      <FullscriptLogoGreenLeafPigeonTextSVGComponent
        css={styles.svgContainer}
        data-testid="fullscript-logo"
      />
    );
  };

  return (
    <Arrange isVertical justify="center" alignment="center" css={styles.fullHeight}>
      {fsLogo()}
      {!!pracAvatar && (
        <Avatar
          image={pracAvatar}
          label={t(l.patientRxAuth.storeLandingPages.leftColumn.pracAvatar, {
            storeName,
            interpolation: { escapeValue: false },
          })}
          size="large"
        />
      )}
      <Typography type="h4">
        {t(l.patientRxAuth.storeLandingPages.leftColumn.tips, {
          storeName,
          interpolation: { escapeValue: false },
        })}
      </Typography>
      {children}
    </Arrange>
  );
};

export { PatientInfoBlock };
